<div class="modal fade" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    <span *ngIf="!editMode">Adicionar novo Contato</span>
                    <span *ngIf="editMode">Editar Contato</span>
                </h4>                 
            </div>
            <div class="modal-body">
                <ng-template [ngIf]="isLoading">
                    <p class="text-center">
                        <i class='fas fa-spinner fa-pulse'></i> Carregando contato
                    </p>
                </ng-template>
                
                <ng-template [ngIf]="!isLoading">
                    <div class="row" *ngIf="lead">
                        <div class="form-group col-12">
                            <label class="col-form-label">Lead</label>
                            <input type="text" class="form-control" [value]="lead.nome" disabled="disabled" readonly="readonly">
                            <p class="form-text text-muted">
                                {{lead.nomeFantasia}} - {{lead.cnpjCpf}} - {{lead.enderecoPrincipal.cidade?.nome}} - {{lead.enderecoPrincipal.cidade?.estado?.uf}}
                            </p>
                        </div>
                    </div>

                    <hr/>

                    <div class="row" *ngIf="showForm">
                        <div class="col-12">
                            <sgt-lead-contato-form
                                #form>
                            </sgt-lead-contato-form>
                        </div>
                    </div>
                </ng-template>                
            </div>
            <div class="modal-footer">      
                <button type="button" class="btn btn-light" (click)="close()">
                    Cancelar
                </button>
                <button type="button" class="btn btn-success" (click)="save()" id="btnLeadContatoSave">
                    Salvar
                </button>                         
            </div>            
        </div>
    </div>
</div>